@if (optimisations.length) {
  <pr-panel clazz="d-flex">
    <div>
      <svg-icon-sprite
        style="padding-top: 10px; padding-bottom: 10px; float: right"
        class="hidden-xs pal"
        [src]="'assets/svg/sprite.svg#mia_screen'"
        [viewBox]="'0 0 115 110'"
        [width]="'115px'"
        [height]="'110px'"
      ></svg-icon-sprite>
      <pr-panel-header title="Les conseils d'albR"></pr-panel-header>
      <pr-panel-body clazz="pal p-t-0">
        <p class="secondary-text hidden-xs">
          Suite à l’analyse de votre patrimoine, albR a découvert quelques
          optimisations à effectuer dans le but de réduire vos frais et
          d’augmenter votre rendement ! N’hésitez pas à échanger avec votre
          conseiller sur ces différentes opportunités.
        </p>
        <div
          class="grid-col-sm-1 grid-col-2 grid"
          style="clear: both"
          accordion
        >
          @for (item of optimisations; track item) {
            <div
              class="ea-card ea-card-hover pointer"
              (click)="openOptimization(item)"
              [style.border-left]="'3px solid ' + item.style.backgroundColor"
            >
              <div class="d-flex justify-content-space-between">
                <p class="primary-text" [innerHtml]="item.label"></p>
              </div>
              <p class="secondary-text" [innerHtml]="item.secondLabel"></p>
              <p class="see-more man">En savoir plus</p>
            </div>
          }
        </div>
      </pr-panel-body>
    </div>
  </pr-panel>
}
